module.exports = __webpack_public_path__ + "static/media/know01.d72924b9.jpg";